var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8479 23.9176L14.848 23.9177C15.5352 24.6233 15.5352 25.7764 14.848 26.4819C14.1756 27.1723 13.0974 27.1731 12.4241 26.4819L1.5148 15.2812C0.828306 14.5764 0.827164 13.4282 1.51879 12.7195L1.51949 12.7188L12.4288 1.51809C13.1016 0.827304 14.1799 0.827304 14.8527 1.51809C15.5399 2.22363 15.5399 3.37672 14.8527 4.08226L10.2521 8.80568C9.01777 10.073 9.91572 12.2011 11.6849 12.2011L27.2727 12.2011C28.2034 12.2011 29 12.9806 29 14.0013C29 15.022 28.2034 15.8015 27.2727 15.8015L11.6843 15.8015C9.91533 15.8015 9.01729 17.9293 10.2513 19.1967L14.8479 23.9176Z",
    stroke: "#738395",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavVector);
export default __webpack_public_path__ + "static/media/nav-Vector.bf56fda3bd4bafa42c0531daa8d450ed.svg";
export { ForwardRef as ReactComponent };